import { alertConstantes } from "@/constantes/alert";

class AlertManager {
  setAlertColorLevel(alerts) {
    let alertColorLevel = 1;
    alerts.forEach((alert) => {
      if (alertColorLevel < alert.level) {
        alertColorLevel = alert.level;
      }
    });
    return alertColorLevel;
  }
  getAlertColor(alertLevel) {
    switch (alertLevel) {
      case alertConstantes.ALERT_INFO:
        return "-info";
      case alertConstantes.ALERT_WARNING:
        return "-warning";
      case alertConstantes.ALERT_DANGER:
        return "-danger";
      default:
        return "-info";
    }
  }

  getAlertIcon(alertLevel) {
    switch (alertLevel) {
      case alertConstantes.ALERT_INFO:
        return "info-circle";
      case alertConstantes.ALERT_WARNING:
        return "triangle-exclamation";
      case alertConstantes.ALERT_DANGER:
        return "circle-exclamation";
      default:
        return "info-circle";
    }
  }
}

export const alertManager = new AlertManager();
